// extracted by mini-css-extract-plugin
module.exports = {"button":"global_button__PLbzI","hPad":"global_hPad__2kf9r","csIntro":"global_csIntro__EbiiY"};